import { CodedProperty } from "sprint-common-web";

import { CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID } from "../../../../../common/api/master-api/common/consts";

export interface OriginSubtitlesFileName {
    languageId: string;
    targetFilename?: string;
}

export interface SequencedSubtitles {
    id: string;
    index: number;
    targetFilename?: string;
}

export const isCleanVideoEmbeddedSubtitle = (subtitle?: CodedProperty): boolean => {
    return subtitle?.id === CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID;
};

export const getSequencedSubtitlesIds = ({
    dynamicSubtitles = [],
    originSubtitlesFileNames
}: {
    dynamicSubtitles: CodedProperty[];
    originSubtitlesFileNames?: Array<OriginSubtitlesFileName>;
}): SequencedSubtitles[] => {
    return dynamicSubtitles.map((item, index) => ({
        id: item.id,
        index: index + 1,
        targetFileName: originSubtitlesFileNames?.find((subt) => subt.languageId === item.id)?.targetFilename
    }));
};

export const EmbeddedSubtitle: CodedProperty = {
    id: CLEAN_VIDEO_SUBTITLE_LANGUAGE_ID,
    name: "Clean Video",
    code: "clean-video"
};
